import React from "react";
import { AppBar, Toolbar, Typography, Box, IconButton, InputBase, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsIcon from "@mui/icons-material/Notifications";
import "./top-bar.css"; // Importing the external CSS file
import { useSelector } from "react-redux";
import TextsmsIcon from "@mui/icons-material/Textsms";

const Topbar = () => {
  const user = useSelector((state) => state.auth.user);

  return (
    <AppBar
      position='fixed'
      className='topbar-appbar'
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "white",
        color: "#000",
        width: `calc(100% - 292px)`, // Subtracting the sidebar width
        marginLeft: "300px", // Aligned with the sidebar width
        marginRight: "20px", // Aligned with the sidebar width
        marginTop: "6px",
        boxShadow: "0px 0px 0px rgba(0, 0, 0, 0)", // Correct the boxShadow value
      }}
    >
      <Toolbar className='topbar-toolbar'>
        <Grid container spacing={3}>
          <Grid item xl={8} lg={9} sm={6}>
            <Box className='topbar-search'>
              <SearchIcon />
              <InputBase placeholder='Search' />
            </Box>
          </Grid>
          <Grid item xl={4} lg={3} sm={6}>
            <Grid container spacing={1}>
              <Grid item>
                <IconButton>
                  <TextsmsIcon />
                </IconButton>
                <IconButton>
                  <NotificationsIcon />
                </IconButton>
              </Grid>
              <Grid item>
                <Typography className='topbar-username'>{user?.username}</Typography>
                <Typography className='topbar-username'>
                  {user?.roleid === 3 ? "Line Manager" : user?.roleid === 2 ? "Home Manger" : "Care Taker"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
